require('./RARadioButtonStep.scss');

// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ components
const RadioButton = require('components/radioButton/radioButton');
const { InfoTooltip } = require('components/tooltip/tooltip');
const { EVENT_DETAIL_TOOLTIP } = require('constants/uTagConstants/RAConstants');

class RARadioButtonStep extends React.Component {
    constructor(props) {
        super(props);
        this.isUpdated = this.isUpdated.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    isUpdated() {
        // TODO: Do something on update
    }

    buildTooltip() {
        const { tooltipContent } = this.props;

        if (tooltipContent) {
            return <InfoTooltip text={tooltipContent} />;
        }
    }

    handleChange(value) {
        const { validateStep, step } = this.props;

        if (validateStep) {
            validateStep(step, value);
        }
    }

    render() {
        const {
            className,
            disabled,
            formActions,
            profileModel,
            titleText,
            radioButtons,
            userProfile,
            model,
            onClickTooltip,
            focusAnimated,
        } = this.props;
        const showTooltip = this.buildTooltip();
        const optionList = radioButtons.map(data => ({
            label: data.label.title,
            value: data.id,
        }));
        const classComponent = classNames('ra-radio-buttons__buttons-container', {
            'ra-radio-buttons__buttons-container--center': profileModel === 'userProfile.RASuitabilityTest.answers.323',
        });

        return (
            <section className="ra-radio-buttons">
                <div className="ra-radio-buttons__head">
                    <div className="ra-radio-buttons__title">
                        <h2>
                            {titleText}
                            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
                            <div
                                className="ra-radio-buttons__tooltip-wrapper"
                                onClick={() => {
                                    onClickTooltip(EVENT_DETAIL_TOOLTIP);
                                }}
                            >
                                {showTooltip}
                            </div>
                        </h2>
                    </div>
                </div>
                <div className={classComponent}>
                    <RadioButton
                        className={className}
                        disabled={disabled}
                        focusAnimated={focusAnimated}
                        formActions={formActions}
                        isRequired
                        isUpdated={this.isUpdated}
                        optionsList={optionList}
                        profileModel={profileModel}
                        userProfile={userProfile}
                        model={model}
                        onChange={this.handleChange}
                    />
                </div>
            </section>
        );
    }
}

module.exports = RARadioButtonStep;
